import { PERMISSION_CODES, PORTAL_MODULE_ENUM } from "./constants";

// Unified requirements (feature flags now filled; permissions left empty)
export const PATH_REQUIREMENTS = {
  // "/admin-dashboard": {
  //   features: [],
  //   permissions: [],
  // },
  "/create-branch": {
    features: ["ADMIN_ORGANISATION_SETUP"],
    permissions: [PERMISSION_CODES.BRANCH_MANAGEMENT.CREATE_BRANCH],
  },
  "/branches": {
    features: ["ADMIN_ORGANISATION_SETUP"],
    permissions: [PERMISSION_CODES.BRANCH_MANAGEMENT.VIEW_BRANCHES],
  },

  "/administrative-users": {
    features: ["ADMIN_USER_MANAGEMENT"],
    permissions: [PERMISSION_CODES.USER_MANAGEMENT.VIEW_USERS],
  },
  "/new-user": {
    features: ["ADMIN_USER_MANAGEMENT"],
    permissions: [PERMISSION_CODES.USER_MANAGEMENT.CREATE_USER],
  },

  "/roles": {
    features: ["ADMIN_ROLE_MANAGEMENT"],
    permissions: [PERMISSION_CODES.USER_MANAGEMENT.VIEW_ROLES_AND_PERMISSION],
  },
  "/new-role": {
    features: ["ADMIN_ROLE_MANAGEMENT"],
    permissions: [PERMISSION_CODES.USER_MANAGEMENT.CREATE_ROLES],
  },

  "/employees": {
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_EMPLOYEES],
  },
  "/new-employee": {
    permissions: [PERMISSION_CODES.OPERATIONS.MANAGE_EMPLOYEES],
  },
  "/upload-employees": {
    permissions: [PERMISSION_CODES.OPERATIONS.MANAGE_EMPLOYEES],
  },
  "/referrals": {
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_REFERRALS],
  },

  "/create-policy": {
    features: ["ADMIN_INSURANCE_REQUESTS"],
    permissions: [PERMISSION_CODES.INSURANCE.CREATE_POLICY],
  },
  "/Policies": {
    features: ["ADMIN_INSURANCE_REQUESTS"],
    permissions: [PERMISSION_CODES.INSURANCE.VIEW_POLICIES],
  },

  // Claims
  "/new-claim": {
    features: ["ADMIN_INSURANCE_REQUESTS"],
    permissions: [PERMISSION_CODES.INSURANCE.CREATE_CLAIM],
  },
  "/admin-claims": {
    features: ["ADMIN_INSURANCE_REQUESTS"],
    permissions: [PERMISSION_CODES.INSURANCE.VIEW_CLAIMS],
  },

  // BPM / Developer Tools
  "/Process": {
    features: ["DEVELOPER_TOOL"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_PROCESS_INSTANCES],
  },
  "/business-rules": {
    features: ["DEVELOPER_TOOL"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_BUSINESS_RULES],
  },
  "/rule-table": {
    features: ["DEVELOPER_TOOL_TABLES"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_RULE_TABLES],
  },
  "/forms": {
    features: ["DEVELOPER_TOOL"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_FORMS],
  },
  "/process-launcher": {
    features: ["DEVELOPER_TOOL"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_PROCESS_LAUNCHER],
  },
  "/chains": {
    features: ["DEVELOPER_TOOL_COMMAND_CHAINS"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_COMMAND_CHAINS],
  },
  "/Views": {
    features: ["DEVELOPER_TOOL_VIEWS"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_CUSTOM_VIEWS],
  },
  "/acturial-sheets": {
    features: ["DEVELOPER_TOOL"],
    permissions: [PERMISSION_CODES.BPM_MANAGEMENT.VIEW_ACTUARIAL_SHEETS],
  },
  "/object-definitions": {
    features: ["DEVELOPER_TOOL"],
    permissions: [
      PERMISSION_CODES.PRODUCT_WORKSHOP_MANAGEMENT.VIEW_OBJECT_DEFINITIONS,
    ],
  },

  // General Search
  "/general-search": {
    features: ["ADMIN_GENERAL_SEARCH"],
    permissions: [PERMISSION_CODES.CHANNEL_CUSTOMERS.GENERAL_SEARCH],
  },

  // Mandates (Mono)
  "/mandate-batches-reports": {
    features: ["ADMIN_MONO_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.VIEW_MANDATE_BATCHES,
    ],
  },
  "/mandate-reports": {
    features: ["ADMIN_MONO_MANDATE_COLLECTION"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.VIEW_MANDATES],
  },
  "/create-mandate": {
    features: ["ADMIN_MONO_MANDATE_SETUP"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.CREATE_MANDATE],
  },
  "/mandate/upload-mandate": {
    features: ["ADMIN_MONO_MANDATE_SETUP"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.UPLOAD_MANDATE],
  },

  // Collections (Mono)
  "/collection/reports": {
    features: ["ADMIN_MONO_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.VIEW_COLLECTIONS,
    ],
  },
  "/mandate/collection-report": {
    features: ["ADMIN_MONO_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.VIEW_COLLECTIONS,
    ],
  },
  "/collection/initiate-batch-form": {
    features: ["ADMIN_MONO_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.CREATE_COLLECTION_BATCH,
    ],
  },
  "/collection/initiate-single-form": {
    features: ["ADMIN_MONO_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.CREATE_SINGLE_COLLECTION,
    ],
  },

  // Mandates (NIBSS)
  "/mandate-reports-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_COLLECTION"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.VIEW_MANDATES],
  },
  "/mandate-batches-reports-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.VIEW_MANDATE_BATCHES,
    ],
  },
  "/new-mandate-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_SETUP"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.CREATE_MANDATE],
  },
  "/new-mandate-batch-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_SETUP"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.CREATE_MANDATE],
  },

  // Collections (NIBSS)
  "/collections-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.VIEW_COLLECTIONS,
    ],
  },
  "/collection-batches-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.VIEW_COLLECTIONS,
    ],
  },
  "/new-collection-batch-nibss": {
    features: ["ADMIN_NIBSS_MANDATE_COLLECTION"],
    permissions: [
      PERMISSION_CODES.CHANNEL_COLLECTIONS_MANAGEMENT.CREATE_COLLECTION_BATCH,
    ],
  },

  // Remita Loan
  "/remita-loan-requests": {
    features: ["ADMIN_REMITA_LOAN"],
  },
  "/remita-collection-batches": {
    features: ["ADMIN_REMITA_LOAN"],
  },
  "/remita-new-batch": {
    features: ["ADMIN_REMITA_LOAN"],
  },
  "/remita-prequalification": {
    features: ["ADMIN_REMITA_LOAN"],
  },
  "/remita-collections": {
    features: ["ADMIN_REMITA_LOAN"],
  },

  "/financial-products": {
    features: ["DEVELOPER_TOOL_PRODUCT_DEPOSIT_SETUP"],
    permissions: [
      PERMISSION_CODES.PRODUCT_WORKSHOP_MANAGEMENT.VIEW_FINANCIAL_PRODUCTS,
    ],
  },
  "/insurance": {
    features: ["DEVELOPER_TOOL_PRODUCT_INSURANCE_SETUP"],
    permissions: [
      PERMISSION_CODES.PRODUCT_WORKSHOP_MANAGEMENT.VIEW_INSURANCE_PRODUCTS,
    ],
  },
  "/loan-products": {
    features: ["DEVELOPER_TOOL_PRODUCT_LOAN_SETUP"],
    permissions: [
      PERMISSION_CODES.PRODUCT_WORKSHOP_MANAGEMENT.VIEW_LOAN_PRODUCTS,
    ],
  },
  "/document-template": {
    features: ["DEVELOPER_TOOL_FILE_TEMPLATES"],
    permissions: [
      PERMISSION_CODES.PRODUCT_WORKSHOP_MANAGEMENT.VIEW_DOCUMENT_TEMPLATES,
    ],
  },
  "/html-templates": {
    features: ["DEVELOPER_TOOL_HTML_TEMPLATES"],
    permissions: [
      PERMISSION_CODES.PRODUCT_WORKSHOP_MANAGEMENT.VIEW_HTML_TEMPLATES,
    ],
  },

  // Manage Channels Reports
  "/customers-report": {
    features: ["ADMIN_CUSTOMERS_REPORT"],
    permissions: [PERMISSION_CODES.CHANNEL_CUSTOMERS.VIEW_CUSTOMERS],
  },
  "/liveness-check": {
    features: ["ADMIN_LIVENESS_CHECK"],
    permissions: [PERMISSION_CODES.CHANNEL_CUSTOMERS.VIEW_CUSTOMERS],
  },
  "/loan-requests-report": {
    features: ["ADMIN_LOAN_REQUESTS"],
    permissions: [PERMISSION_CODES.CHANNEL_LOAN_REQUESTS.VIEW_LOAN_REQUESTS],
  },
  "/transactions-report": {
    features: ["ADMIN_TRANSACTIONS_REPORT"],
    permissions: [PERMISSION_CODES.CHANNEL_TRANSACTIONS.VIEW_TRANSACTIONS],
  },

  "/ptsp-transactions-report": {
    features: ["ADMIN_TRANSACTIONS_REPORT"],
    permissions: [PERMISSION_CODES.CHANNEL_TRANSACTIONS.VIEW_TRANSACTIONS],
  },
  "/transfers-report": {
    features: ["ADMIN_TRANSFER_REQUESTS"],
    permissions: [PERMISSION_CODES.CHANNEL_TRANSFERS.VIEW_TRANSFERS],
  },

  "/mandate/selector": {
    features: ["ADMIN_MONO_MANDATE_SETUP"],
    permissions: [PERMISSION_CODES.CHANNEL_MANDATES_MANAGEMENT.CREATE_MANDATE],
  },
  "/general-requests-selector": {
    features: ["ADMIN_MANAGE_CHANNELS"],
    permissions: [PERMISSION_CODES.CHANNEL_ORGANISATIONS.VIEW_ORGANISATIONS],
  },
  "/organisations": {
    features: ["ADMIN_ORGANISATION_SETUP"],
    permissions: [PERMISSION_CODES.CHANNEL_ORGANISATIONS.VIEW_ORGANISATIONS],
  },

  // ===== Appended mappings (previously-unmapped)
  "/contact-lists": {
    features: ["ADMIN_CONTACTS"],
    permissions: [PERMISSION_CODES.CLIENT_MANAGEMENT.VIEW_CLIENTS],
  },
  "/new-contact": {
    features: ["ADMIN_CONTACTS"],
    permissions: [PERMISSION_CODES.CLIENT_MANAGEMENT.CREATE_CLIENT],
  },
  "/communications": {
    features: ["ADMIN_CONTACTS"],
    permissions: [
      PERMISSION_CODES.CLIENT_MANAGEMENT.VIEW_CLIENT_COMMUNICATIONS,
    ],
  },

  "/coa-management": {
    features: ["ADMIN_CHART_OF_ACCOUNTS"],
    permissions: [PERMISSION_CODES.ACCOUNTING.CREATE_CHARTS_OF_ACCOUNTS],
  },
  "/chart-of-accounts": {
    features: ["ADMIN_CHART_OF_ACCOUNTS"],
    permissions: [PERMISSION_CODES.ACCOUNTING.VIEW_CHARTS_OF_ACCOUNTS],
  },

  "/deposit-transactions": {
    features: ["ADMIN_DEPOSIT_OPERATIONS"],
    permissions: [
      PERMISSION_CODES.DEPOSIT_MANAGEMENT.VIEW_DEPOSIT_TRANSACTIONS,
    ],
  },
  "/deposit-fund": {
    features: ["ADMIN_DEPOSIT_OPERATIONS"],
    permissions: [PERMISSION_CODES.DEPOSIT_MANAGEMENT.POST_DEPOSIT],
  },
  "/withdraw-fund": {
    features: ["ADMIN_DEPOSIT_OPERATIONS"],
    permissions: [PERMISSION_CODES.DEPOSIT_MANAGEMENT.POST_WITHDRAWAL],
  },
  "/transfer-fund": {
    features: ["ADMIN_DEPOSIT_OPERATIONS"],
    permissions: [PERMISSION_CODES.DEPOSIT_MANAGEMENT.MAKE_TRANSFER],
  },

  "/loan-transactions": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.VIEW_LOAN_TRANSACTIONS],
  },
  "/loan-repayment": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.APPLY_REPAYMENT],
  },

  "/audit-logs": {
    features: ["ADMIN_AUDIT_LOG"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_AUDIT_LOGS],
  },
  "/system-logs": {
    features: ["ADMIN_SYSTEM_LOG"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_SYSTEM_LOGS],
  },
  "/languages": {
    features: ["ADMIN_LANGUAGE"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_LANGUAGES],
  },
  "/platform-configuration": {
    features: ["ADMIN_PLATFORM_CONFIG"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_PLATFORM_CONFIG],
  },
  "/general-config": {
    features: ["ADMIN_GENERAL_CONFIG"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_GENERAL_CONFIG],
  },
  "/recurring-jobs": {
    features: ["ADMIN_RECURRING_JOBS"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_RECURRING_JOBS],
  },
  "/webhooks": {
    features: ["ADMIN_WEBHOOKS"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_WEBHOOKS],
  },
  "/secure-credentials": {
    features: ["ADMIN_SECURE_CREDENTIALS"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_SECURE_CREDENTIALS],
  },

  "/create-virtual-account": {
    features: ["ADMIN_VIRTUAL_ACCOUNT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.CREATE_VIRTUAL_ACCOUNT],
  },
  "/virtual-accounts": {
    features: ["ADMIN_VIRTUAL_ACCOUNT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.VIEW_VIRTUAL_ACCOUNTS],
  },
  "/new-terminal": {
    features: ["ADMIN_TERMINAL_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.CREATE_TERMINAL],
  },
  "/terminals": {
    features: ["ADMIN_TERMINAL_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.VIEW_TERMINALS],
  },
  "/terminals-transactions": {
    features: ["ADMIN_TERMINAL_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.VIEW_PTSP_TRANSACTIONS],
  },
  "/create-merchant": {
    features: ["ADMIN_MERCHANT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.CREATE_MERCHANT],
  },
  "/merchant-lists": {
    features: ["ADMIN_MERCHANT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.AGENCY_BANKING.VIEW_MERCHANTS],
  },

  // Deposit account management
  "/deposits": {
    features: ["ADMIN_DEPOSIT_ACCOUNT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.DEPOSIT_MANAGEMENT.VIEW_DEPOSIT_ACCOUNTS],
  },
  "/new-deposit": {
    features: ["ADMIN_DEPOSIT_ACCOUNT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.DEPOSIT_MANAGEMENT.CREATE_DEPOSIT],
  },

  // Loan account management
  "/all-loans": {
    features: ["ADMIN_LOAN_ACCOUNT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.VIEW_LOAN_ACCOUNTS],
  },
  "/new-loan": {
    features: ["ADMIN_LOAN_ACCOUNT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.CREATE_LOAN],
  },

  "/schema": {
    features: ["DEVELOPER_TOOL_SCHEMA"],
    permissions: [PERMISSION_CODES.SETTINGS.VIEW_SCHEMA],
  },

  // ===== Additional menu mappings (sync: Nov 27, 2025) =====
  "/teller-dashboard": {
    features: ["ADMIN_TELLER_MANAGEMENT"],
    permissions: [PERMISSION_CODES.TELLER_MANAGEMENT.VIEW_TELLER_DASHBOARD],
  },
  "/teller-transaction": {
    features: ["ADMIN_TELLER_MANAGEMENT"],
    permissions: [PERMISSION_CODES.TELLER_MANAGEMENT.VIEW_TELLER_TRANSACTIONS],
  },
  "/tills": {
    features: ["ADMIN_TELLER_MANAGEMENT"],
    permissions: [PERMISSION_CODES.TELLER_MANAGEMENT.VIEW_TELLER_TILLS],
  },

  "/sil-tellering-dashboard": {
    features: ["ADMIN_SIL_TELLERING_DASHBOARD"],
    permissions: [PERMISSION_CODES.TELLER_MANAGEMENT.VIEW_TELLER_DASHBOARD],
  },
  "/branch-vault": {
    features: ["ADMIN_VAULT_MANAGEMENT"],
    permissions: [PERMISSION_CODES.TELLER_MANAGEMENT.VIEW_TELLER_VAULTS],
  },
  "/branch-vaults-transactions": {
    features: ["ADMIN_VAULT_MANAGEMENT"],
    permissions: [
      PERMISSION_CODES.TELLER_MANAGEMENT.VIEW_TELLER_VAULTS_TRANSACTIONS,
    ],
  },

  "/self-service-users": {
    features: ["ADMIN_USER_MANAGEMENT"],
    permissions: [PERMISSION_CODES.USER_MANAGEMENT.VIEW_USERS],
  },

  "/cheque-registrations": {
    features: ["ADMIN_CHEQUE_MANAGEMENT"],
    permissions: [PERMISSION_CODES.CHEQUE_MANAGEMENT.VIEW_CHEQUE_CLEARING],
  },
  "/new-request": {
    features: ["ADMIN_CHEQUE_MANAGEMENT"],
    permissions: [PERMISSION_CODES.CHEQUE_MANAGEMENT.CLEAR_CHEQUE_CLEARING],
  },

  "/disburse-loan": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.DISBURSE_LOAN_ACCOUNT],
  },
  "/write-off-loan": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.WRITEOFF_LOAN],
  },
  "/refinance-loan": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.REFINANCE_LOAN],
  },
  "/reschedule-loan": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.RESCHEDULE_LOAN],
  },
  "/pay-off-loan": {
    features: ["ADMIN_LOAN_OPERATIONS"],
    permissions: [PERMISSION_CODES.LOAN_MANAGEMENT.PAYOFF_LOAN],
  },

  "/inward-transactions": {
    features: ["ADMIN_INWARD_TRANSACTION_OPERATION"],
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_INWARD_TRANSACTIONS],
  },
  "/outward-transactions": {
    features: ["ADMIN_OUTWARD_TRANSACTION_OPERATION"],
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_OUTWARD_TRANSACTIONS],
  },
  "/data-ingestion": {
    features: ["ADMIN_DATA_INGESTION_OPERATION"],
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_DATA_INGESTION],
  },
  "/evaluate-alert": {
    features: ["ADMIN_EVALUATE_ALERT_OPERATION"],
    permissions: [PERMISSION_CODES.OPERATIONS.EVALUATE_ALERT],
  },
  "/alert-monitoring": {
    features: ["ADMIN_ALERT_MONITORING_OPERATION"],
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_ALERT_MONITORING],
  },
  "/reconciliation": {
    features: ["ADMIN_RECONCILIATION_OPERATION"],
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_RECONCILIATION],
  },

  // DIRECT CONFIGURATIONS

  "/direct-configuration/PTSP": {
    features: ["ADMIN_GENERAL_CONFIG"],
    permissions: [
      PERMISSION_CODES.SETTINGS.VIEW_GENERAL_CONFIG,
      PERMISSION_CODES.AGENCY_BANKING.CONFIGURE_PTSP,
    ],
  },
  "/direct-configuration/VirtualAccountProvider": {
    features: ["ADMIN_GENERAL_CONFIG"],
    permissions: [
      PERMISSION_CODES.SETTINGS.VIEW_GENERAL_CONFIG,
      PERMISSION_CODES.AGENCY_BANKING.CONFIGURE_VIRTUAL_ACCOUNT,
    ],
  },
  "/direct-configuration/TRANSACTION_MONITORING_CONFIGURATION": {
    features: ["ADMIN_GENERAL_CONFIG"],
    permissions: [
      PERMISSION_CODES.SETTINGS.VIEW_GENERAL_CONFIG,
      PERMISSION_CODES.OPERATIONS.CONFIGURE_TRANSACTION_MONITORING,
    ],
  },
  "/direct-configuration/RECON": {
    features: ["ADMIN_GENERAL_CONFIG"],
    permissions: [
      PERMISSION_CODES.SETTINGS.VIEW_GENERAL_CONFIG,
      PERMISSION_CODES.OPERATIONS.CONFIGURE_RECONCILIATION,
    ],
  },

  // "/journals-entry": {
  //   features: ["ADMIN_CREATE_JOURNAL_ENTRY"],
  //   permissions: [
  //     PERMISSION_CODES.ACCOUNTING.CREATE_JOURNAL_ENTRIES,
  //   ],
  // },

  // "/journals": {
  //   features: ["ADMIN_JOURNALS"],
  //   permissions: [
  //     PERMISSION_CODES.ACCOUNTING.VIEW_JOURNAL_ENTRIES,
  //   ],
  // },

  "/journals-entry": {
    features: ["ADMIN_CREATE_JOURNAL_ENTRY"],
    permissions: [PERMISSION_CODES.ACCOUNTING.CREATE_JOURNAL_ENTRIES],
  },

  "/journals": {
    features: ["ADMIN_JOURNALS"],
    permissions: [PERMISSION_CODES.ACCOUNTING.VIEW_JOURNAL_ENTRIES],
  },

  "/journal-transactions": {
    features: ["ADMIN_JOURNAL_TRANSACTIONS"],
    permissions: [PERMISSION_CODES.ACCOUNTING.VIEW_JOURNAL_ENTRIES],
  },

  "/closures": {
    features: ["ADMIN_BRANCH_CLOSURES"],
    permissions: [PERMISSION_CODES.BRANCH_MANAGEMENT.MANAGE_BRANCH_CLOSURE],
  },

  "/books": {
    features: ["ADMIN_BOOK_MANAGEMENT"],
    permissions: [PERMISSION_CODES.OPERATIONS.VIEW_BOOKS],
  },

  "/book-management": {
    features: ["ADMIN_BOOK_MANAGEMENT"],
    permissions: [PERMISSION_CODES.OPERATIONS.MANAGE_BOOKS],
  },

  "/interbranch-accounting": {
    features: ["ADMIN_INTERBRANCH_ACCOUNTING"],
    permissions: [PERMISSION_CODES.ACCOUNTING.VIEW_INTERBRANCH_CONTROLS],
  },

  "/uncleared-cheques": {
    features: ["ADMIN_CHEQUE_MANAGEMENT"],
    permissions: [PERMISSION_CODES.CHEQUE_MANAGEMENT.VIEW_UNCLEARED_CHEQUES],
  },
  "/cheque-transactions": {
    features: ["ADMIN_CHEQUE_MANAGEMENT"],
    permissions: [PERMISSION_CODES.CHEQUE_MANAGEMENT.VIEW_CHEQUE_TRANSACTIONS],
  },
};

export const findMatchingPathRequirement = (pathname) => {
  const entries = Object.entries(PATH_REQUIREMENTS);
  for (const [pattern, requirement] of entries) {
    if (pathname === pattern || pathname.startsWith(pattern + "/")) {
      console.log("requirement??? ?", requirement);
      return requirement;
    }
  }
  return null;
};
